<template>
	<div class="chat-container w-100 position-relative">
		<template v-if="isOpen">
	    <div class="container mt-5">
				<img :src="getMerchant().image_url" :alt="getMerchant().name" class="d-block mx-auto mb-3" :style="{width: getMerchant().search_room_merchant_image_width + 'px'}">
	    	<div class="px-2">
	    		<p class="mb-1 heading-5 text-center">{{$t('profile.login.welcome-back')}}!</p>
	    		<p class="mb-0 body-1 font-regular text-center w-90 mx-auto">{{$t('profile.login.sub-heading')}}</p>
	    		<div class="mb-2">
		    		<p class="mb-0 mt-4 font-regular body-2 text-color-dark">{{$t('profile.login.email')}}</p>
		    		<input type="email" class="form-control pl-3 mt-2 body-1-2 mb-0 border-semi-grey rounded-6" v-model="login_form.email" placeholder="user@guestaps.com">
	    		</div>
	    		<div class="mb-2">
	    			<div class="w-100 pb-3 mt-4" style="height:23px">
			    		<p class="mb-0 font-regular body-2 text-color-dark float-left">{{$t('profile.login.password')}}</p>
			    		<p class="mb-0 font-semibold body-2 text-green float-right cursor-pointer" @click="goForgotPass()"><u>{{$t('profile.forgot-password')}}?</u></p>
	    			</div>
						<div class="position-relative">
							<input :type="pass_blink?'text':'password'" class="form-control pl-3 mt-2 body-1-2 mb-0 pr-5 border-semi-grey rounded-6" v-model="login_form.password">
							<div class="cursor-pointer position-absolute" style="top:8px;right:16px;" @click="pass_blink = !pass_blink">
            		<img v-if="pass_blink" src="../../assets/img/affiliate/icon/hide.svg" width="24">
            		<img v-else src="../../assets/img/affiliate/icon/show.svg" width="24">
			    		</div>
						</div>
	    		</div>
	    	</div>
    	</div>
			<div class="container mt-5 mb-1">
        <div class="px-2">
        	<div v-if="error.show" class="p-3 border mb-3 radius-0 text-center" style="background-color: rgb(255, 243, 243); border-color: rgb(254, 184, 184) !important;">
            <p class="mb-0 body-3-1">{{error.message}}</p>
          </div>
        	<div @click="loginSubmit" class="bg-green rounded-6 px-4 py-3 text-center cursor-pointer" :class="{'bg-green': is_login_form_valid, 'bg-green-disabled' : !is_login_form_valid}">
        		<pulse-loader :loading="push_loading" v-if="push_loading"></pulse-loader>
            <p v-else class="text-white body-15 mb-0 ls-1-25">{{$t('profile.login.login')}}</p>
          </div>
        </div>
    	</div>
    	<div class="container text-center pb-4">
    		<div class="row slim-grid-row">
    			<div class="col-4 border-bottom px0"></div>
    			<div class="col-4 px0">
	      		<p class="mb-0 d-inline-block text-center body-3 text-color-dark position-relative" style="top: 10px;">{{$t('profile.not-register')}}?</p>
    			</div>
    			<div class="col-4 border-bottom px0"></div>
    		</div>
    	</div>
    	<div class="container mb-4">
    		<div class="px-2">
        	<div class="rounded-6 px-4 py-14px text-center cursor-pointer box-shadow-bold border-green" @click="showRegister">
            <p class="body-15 mb-0 ls-0-25 text-green">{{$t('profile.create-account')}}</p>
          </div>
        </div>
    	</div>
	    <div class="container">
	     	<div class="px-2">
	     		<p class="font-regular text-12 ls-0-25 text-center">{{$t('profile.login.agreement')}}</p>
	     	</div>
	     </div>
		</template>
	</div>
</template>
<script>
	const { email,required } = require("vuelidate/lib/validators");
	import {post} from '@/services/index.js';
	import {checkDataExist} from '@/utils/index.js';
	import {mapActions,mapGetters,mapMutations} from 'vuex';

	export default{
		data() {
			return {
				isOpen: true,
				isInput: true,
				isCode: false,
				login_form:{
					email: '',
					password: ''
				},
				error: {
					show: false,
					message: ''
				},
				push_loading: false,
				pass_blink: false
			}
		},
		computed:{
			is_login_form_valid(){
        return (this.$v.login_form.email.$invalid == false && this.$v.login_form.password.$invalid == false) ? true : false
      },
      previousPage(){
        if(this.$isEmpty(this.$route.query) || this.$isEmpty(this.$route.query.next_page)) return ""
        return this.$route.query.next_page;
      }
		},
		validations: {
      login_form: {
        email:{
         	required,
          email
        },
        password:{
        	required
        }
      },
    },
    mounted(){
      this.$validateUserMenu();
    	if (!this.isNotLogin()) {
    		this.$router.push({
    			path: '/'+this.getMerchant().code+'/account'
    		})
    	}
    },
		methods: {
			...mapGetters(['isNotLogin','getMerchant','getActiveRoute','getMetaTitleTemplate','getConciergeAuth','isReservationActive']),
			...mapMutations(['setConciergeAuth','setReservationActive']),
			...mapActions(['setToken','setUser','setForgotPassword']),
			showRegister() {
        const { code } = this.getMerchant(); 
        let params = {
          path: `/${code}/register`,
          query: {}
        }
        if(this.$isNotEmptyV2(this.previousPage)){
          params.query.next_page = this.previousPage;
        }
				this.$router.push(params)
			},
			showInput() {
				this.isInput =!this.isInput
			},
			showCode() {
				this.isCode = !this.isCode
				this.isInput =!this.isInput
			},
			loginSubmit(){
				if (this.is_login_form_valid) {
					this.push_loading = true
					post('BASE','auth/token',{
						username: this.login_form.email,
						password: this.login_form.password,
						fcm_token: ''
					}).then(response=>{
						if (response.status == 401) {
							this.error.show = true
							this.error.message = "We couldn't find and account matching the email and password you entered. Please check your email and password and try again."
						}else{
							let res = response.data;
							if (checkDataExist(res.access_token)) {
								this.error.show = false
								this.error.message = ""
								this.setToken({
									access: res.access_token,
	      					refresh: res.refresh_token
								})
								this.setUser(res.user)
								this.setForgotPassword("")

                const queryNextPage = this.$route.query.next_page;
                if(this.$isNotEmptyV2(queryNextPage)){
                  let nextRouteParams = {
										name: queryNextPage,
                    params: {}
									}

                  const paramNextPage = this.$route.query.params;
                  if(paramNextPage){
                    const splittedData = paramNextPage.split(".")
                    nextRouteParams.params[splittedData[0]] = splittedData[1]
                  }

                  nextRouteParams.params = {
                    merchant_code: this.getMerchant().code
                  }
                  
                  this.$router.push(nextRouteParams)
                }else{
                  let next_page = this.getActiveRoute() != '' ? `/${this.getMerchant().code}/${this.getActiveRoute()}` : `/${this.getMerchant().code}/account`
                  if(this.getMerchant().merchant_type == 'hotel'){
                    if(this.isReservationActive()){
                      this.$router.push({
                        path: next_page
                      })
                    }else{
                      this.$getReservationFromAuth().then(rsv_res=>{
                        if(rsv_res.length > 0){
                          let params_vuex = [
                            { key : 'booking_number', value: rsv_res[0].booking_number },
                            { key : 'detail_id', value: rsv_res[0].pms_detail_id },
                            { key : 'folio', value: rsv_res[0].folio_number },
                            { key : 'user_id', value: rsv_res[0].guest_profile.user }
                          ]
                          this.setReservationActive(params_vuex)
                        }
                        this.$router.push({
                          path: next_page
                        })
                      })	
                    }
                  }else{
                    this.$router.push({
                      path: next_page
                    })
                  }
                }
                
							}else{
								this.error.show = true
								this.error.message = res.message
							}
						}
						this.push_loading = false
					})
				}
			},
			goForgotPass(){
				this.$router.push({
					path: '/'+this.getMerchant().code+'/reset-password'
				})
			}
		}
	}
</script>
<style scoped>
	.px0{
		padding-left: 0px!important;
		padding-right: 0px!important;
	}
</style>


// WEBPACK FOOTER //
// src/pages/general/Login.vue